import React from "react";
import {connect} from "react-redux";
import EditBookMetaData from "./forms/EditBookMetaData";
import {chBookTitle, chBookDescription, chCha} from "../action/books";
import {Redirect} from "react-router-dom";

class EditMetaData extends React.Component{
    constructor(props) {
      super(props);
      this.state = {};
    }
    chBookTitle=(data)=>{this.setState({loading: true});this.props.chBookTitle(data).then(msg => {this.setState({loading: false});window.location.reload();})};
    chBookDescription=(data)=>{this.setState({loading: true});this.props.chBookDescription(data).then(msg => {this.setState({loading: false});window.location.reload();})};
    chCha=(data)=>{this.setState({loading: true});this.props.chCha(data).then(msg => {this.setState({loading: false});window.location.reload();})};
    render(){
        return(
            <div>
                {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
                {this.props.books && (
                <EditBookMetaData 
                    books={this.props.books[this.props.bookId]}
                    chBookTitle={this.chBookTitle}
                    chBookDescription={this.chBookDescription}
                    chTotalChapters={this.chCha}
                />)
                }
            </div>
        );
    };
};

function mapStateToProps (state) {
    return {books: state.AllBooks.books}
}

export default connect(mapStateToProps, {chBookTitle, chBookDescription, chCha})(EditMetaData);